import {DomainError} from '@s-ui/domain'

export class GetAdContactPhoneAdsError extends DomainError {
  #cause
  #code
  #message

  static GENERIC_ERROR_CODE = 'generic_get_ad_contact_phone_ads_error'
  static INVALID_AD_ID_ERROR_CODE = 'invalid_ad_id_get_ad_contact_phone_ads_error'
  static USER_PHONE_NOT_AVAILABLE_ERROR_CODE = 'user_phone_not_available_get_ad_contact_phone_ads_error'
  static AD_NOT_FOUND_ERROR_CODE = 'ad_not_found_get_ad_contact_phone_ads_error'
  static UNAUTHORIZED_ERROR_CODE = 'unauthorized_get_ad_contact_phone_ads_error'
  static TOO_MANY_REQUESTS_ERROR_CODE = 'too_many_requests_get_ad_contact_phone_ads_error'

  constructor({cause, code, message}) {
    super({cause, code, message})
    this.#cause = cause
    this.#code = code
    this.#message = message
  }

  static isGetAdContactPhoneAdsError({error}) {
    return error instanceof GetAdContactPhoneAdsError
  }

  static create({code, message, cause}) {
    return new GetAdContactPhoneAdsError({code, message, cause})
  }

  static createGenericError({cause}) {
    return GetAdContactPhoneAdsError.create({
      code: GetAdContactPhoneAdsError.GENERIC_ERROR_CODE,
      cause,
      message: 'ERRORS.GET_AD_CONTACT_PHONE_ADS.GENERIC'
    })
  }

  static createInvalidAdIdError() {
    return GetAdContactPhoneAdsError.create({
      code: GetAdContactPhoneAdsError.INVALID_AD_ID_ERROR_CODE,
      message: 'ERRORS.GET_AD_CONTACT_PHONE_ADS.INVALID_AD_ID'
    })
  }

  static createUserPhoneNotAvailableError() {
    return GetAdContactPhoneAdsError.create({
      code: GetAdContactPhoneAdsError.USER_PHONE_NOT_AVAILABLE_ERROR_CODE,
      message: 'ERRORS.GET_AD_CONTACT_PHONE_ADS.USER_PHONE_NOT_AVAILABLE'
    })
  }

  static createAdNotFoundError() {
    return GetAdContactPhoneAdsError.create({
      code: GetAdContactPhoneAdsError.AD_NOT_FOUND_ERROR_CODE,
      message: 'ERRORS.GET_AD_CONTACT_PHONE_ADS.AD_NOT_FOUND'
    })
  }

  static createUnauthorizedError() {
    return GetAdContactPhoneAdsError.create({
      code: GetAdContactPhoneAdsError.UNAUTHORIZED_ERROR_CODE,
      message: 'ERRORS.GET_AD_CONTACT_PHONE_ADS.UNAUTHORIZED'
    })
  }

  static createTooManyRequestsError() {
    return GetAdContactPhoneAdsError.create({
      code: GetAdContactPhoneAdsError.TOO_MANY_REQUESTS_ERROR_CODE,
      message: 'ERRORS.GET_AD_CONTACT_PHONE_ADS.TOO_MANY_REQUESTS'
    })
  }

  get value() {
    return {
      code: this.#code,
      message: this.message,
      cause: this.cause
    }
  }

  isGenericError() {
    return this.#code === GetAdContactPhoneAdsError.GENERIC_ERROR_CODE
  }

  isInvalidAdIdError() {
    return this.#code === GetAdContactPhoneAdsError.INVALID_AD_ID_ERROR_CODE
  }

  isUserPhoneNotAvailableError() {
    return this.#code === GetAdContactPhoneAdsError.USER_PHONE_NOT_AVAILABLE_ERROR_CODE
  }

  isAdNotFoundError() {
    return this.#code === GetAdContactPhoneAdsError.AD_NOT_FOUND_ERROR_CODE
  }

  isUnauthorizedError() {
    return this.#code === GetAdContactPhoneAdsError.UNAUTHORIZED_ERROR_CODE
  }

  isTooManyRequestsError() {
    return this.#code === GetAdContactPhoneAdsError.TOO_MANY_REQUESTS_ERROR_CODE
  }

  toJSON() {
    return {
      code: this.#code,
      message: this.#message,
      cause: this.#cause
    }
  }
}
